import React, {Component} from 'react';
import './Button.css';

class Button extends Component {
    render() {
        const {btnText, extraClassName, absoluteUrl} = this.props;

        if (absoluteUrl === 'disabled') {
            return (
                <button disabled={true} className={`btn-default ${extraClassName}`}
                        onClick={this.handleOnclick.bind(this)}>{btnText}</button>
            )
        } else {
            return (
                <button className={`btn-default ${extraClassName}`}
                        onClick={this.handleOnclick.bind(this)}>{btnText}</button>
            )
        }
    }

    handleOnclick() {
        const { absoluteUrl} = this.props;
        if(absoluteUrl.length === 0){
            return;
        }
        window.open(absoluteUrl);
    }
}

export default Button;
